import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import moment from "moment";
import { isEmpty, startCase } from "lodash";

import CustomDatePicker from "../../components/CustomDatePicker";
import ProfitLossReportModal from "./ProfitLossReportModal";
import MyAccountFilter from "../MyAccount/MyAccountFilter";
import Pagination from "../../components/Pagination";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { toFixedWithoutRounding } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";

const eventTypeLabel = (eventType) =>
  eventType === "4"
    ? "Cricket"
    : eventType === "1"
      ? "Soccer"
      : eventType === "2"
        ? "Tennis"
        : eventType === "7"
          ? "Horse Racing"
          : "Casino";

const ReportByMarket = () => {
  const params = useParams();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const tableRef = useRef();

  const previousDate = moment()
    .subtract(1, "day")
    .format("YYYY-MM-DD HH:mm:ss");
  const currentDate = moment().format("YYYY-MM-DD HH:mm:ss");

  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    fromPeriod: previousDate,
    toPeriod: currentDate,
    // filterByDay: "",
    created_by: params?.id || user?._id,
    userType: params?.user_type || user?.userType,
    eventType: "all",
    // market: "",
    // event: "",
  };

  const [filter, setFilter] = useState(DEFAULT_FILTER);
  const [data, setData] = useState([]);
  const [sumData, setSumData] = useState({});
  const [show, setShow] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.reportMarket,
      activeFilter,
    );
    if (status === 200 && response_users.success) {
      const rows = response_users.results?.data || [];
      setData(rows);

      const stake = rows.reduce((a, v) => a + Number(v?.stake || 0), 0);
      const commission = rows.reduce(
        (a, v) => a + Number(v?.commission || 0),
        0,
      );
      const downlinePnl = rows.reduce((a, v) => a + Number(v?.amount || 0), 0);
      setSumData({ stake, commission, downlinePnl });
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.page, filter.limit]);

  const applyPreset = (preset) => {
    const nextFilter = { ...filter, page: 1, filterByDay: preset };
    if (preset === "today") {
      nextFilter.fromPeriod = moment()
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    } else if (preset === "yesterday") {
      nextFilter.fromPeriod = moment()
        .subtract(1, "day")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      nextFilter.toPeriod = moment()
        .subtract(1, "day")
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
    }
    setFilter(nextFilter);
    if (filter.page === nextFilter.page) getData(nextFilter);
  };

  const handleLimitChange = (e) =>
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));

  const openMarket = (item) => {
    setDetailsData(item);
    setShow(true);
  };

  const plSpan = (value) =>
    value ? (
      Math.sign(value) === -1 ? (
        <span className="red">({toFixedWithoutRounding(Math.abs(value))})</span>
      ) : (
        <span>{toFixedWithoutRounding(Math.abs(value))}</span>
      )
    ) : (
      "0.00"
    );

  const totalRecords = data?.length || 0;

  return (
    <app-pnl-match className="ng-star-inserted">
      <div className="main_wrap">
        <div className="box">
          <h2>Profit/Loss Report by Market</h2>
        </div>

        <div className="function-wrap funwrap">
          <ul className="input-list flowroot">
            <li>
              <label>Sports</label>
            </li>
            <li>
              <select
                id="func_sports"
                value={filter.eventType}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, eventType: e.target.value }))
                }
              >
                <option value={"all"}>All</option>
                <option value="1">SOCCER</option>
                <option value="2">TENNIS</option>
                <option value="4">CRICKET</option>

                <option value="-1">CASINO</option>
              </select>
            </li>
            <li />
            <li>
              <label>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />
            <li>
              <input
                name="sortCondition"
                placeholder="Search Market"
                value={filter.market}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, market: e.target.value }))
                }
              />
            </li>
            <li>
              <input
                placeholder="Search Event"
                value={filter.event}
                onChange={(e) =>
                  setFilter((prev) => ({ ...prev, event: e.target.value }))
                }
              />
            </li>
          </ul>
          <ul className="input-list flowroot">
            <li>
              <a
                id="today"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("today");
                }}
              >
                Just for today
              </a>
            </li>
            <li>
              <a
                id="yesterday"
                className="btn"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("yesterday");
                }}
              >
                From yesterday
              </a>
            </li>
            <li>
              <a
                id="getPL"
                className="btn-send"
                onClick={(e) => {
                  e.preventDefault();
                  getData(filter);
                }}
              >
                Get P &amp; L
              </a>
            </li>
          </ul>
        </div>

        <div className="total_all">
          <span>
            <label>Last:</label>
            <select
              name="limit"
              id="limit"
              value={filter.limit}
              onChange={handleLimitChange}
            >
              <option value={10}>10 Txn</option>{" "}
              <option value={25}>25 Txn</option>{" "}
              <option value={50}>50 Txn</option>
              <option value={100}>100 Txn</option>
            </select>
          </span>
          <div className="spacer" />
          <span className="total-users" style={{ fontWeight: "600" }}>
            {" "}
            Total Records: {totalRecords}
          </span>
          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName="report-market"
          />
        </div>

        <div
          id="reportDiv"
          className="over-wrap"
          style={{ maxHeight: "calc(100% - 32px - 93px)" }}
        >
          <div className="table-responsive data-table">
            <table ref={tableRef} id="table_DL" className="table01 table-pt">
              <tbody>
                <tr id="head">
                  <th
                    width="35%"
                    id="header_eventName"
                    className="align-L sort_asc"
                  >
                    Event
                  </th>
                  <th width="22%" className="sort_asc">
                    {" "}
                    Event/Market Name{" "}
                  </th>
                  <th width="5%" className="sort_asc">
                    {" "}
                    Stake{" "}
                  </th>
                  <th width="10%" className="sort_asc">
                    {" "}
                    Casino P/L
                  </th>
                  <th
                    id="header_profitLoss_downLine"
                    width="10%"
                    className="sort_asc"
                  >
                    {" "}
                    Downline P/L{" "}
                  </th>
                  <th
                    id="header_tax_agent_3"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    Master Comm.{" "}
                  </th>
                  <th
                    id="header_rebate_agent_3"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    Master Rebate{" "}
                  </th>
                  <th id="header_tax_agent_2" width="10%" className="sort_asc">
                    Super Comm.
                  </th>
                  <th
                    id="header_rebate_agent_2"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    Super Rebate{" "}
                  </th>
                  <th
                    id="header_payout_agent_1"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    SS PT{" "}
                  </th>
                  <th
                    id="header_tax_agent_1"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    SS Comm.{" "}
                  </th>
                  <th
                    id="header_rebate_agent_1"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    SS Rebate{" "}
                  </th>
                  <th
                    id="header_profitLoss_agent_1"
                    width="15%"
                    style={{ display: "none" }}
                  >
                    {" "}
                    SS Total{" "}
                  </th>
                  <th width="15%" className="sort_asc">
                    {" "}
                    Upline P/L
                  </th>
                </tr>
              </tbody>

              <tbody id="content">
                {!isEmpty(data) ? (
                  data.map((item, index) => (
                    <tr
                      key={item?._id || index}
                      id={`main_${item?.eventId || index}`}
                    >
                      <td className="align-L">
                        <a href="#">
                          <span id="_eventType">
                            {eventTypeLabel(item?.eventType)}
                          </span>
                          <img
                            src="/assets/images/transparent.gif"
                            className="fromto"
                            alt=""
                          />
                          <strong id="_eventName">
                            {item?.matchName || item?.gameType}
                          </strong>
                        </a>
                      </td>
                      <td className="align-R">
                        <a
                          href="#"
                          onClick={(e) => {
                            e.preventDefault();
                            openMarket(item);
                          }}
                        >
                          <span id="_marketName">
                            {startCase(item?.betFaireType) ||
                              item?.marketName ||
                              "-"}
                          </span>
                        </a>
                      </td>
                      <td className="align-R">
                        <a>
                          <span id="_stake">
                            {toFixedWithoutRounding(item?.stake || 0)}
                          </span>
                        </a>
                      </td>
                      <td id="_profitLoss">{plSpan(item?.amount)}</td>
                      <td>{plSpan(item?.amount)}</td>
                      <td id="_tax3" style={{ display: "none" }}>
                        0.00
                      </td>
                      <td id="_rebate3" style={{ display: "none" }}>
                        0.00
                      </td>
                      <td id="_tax2">
                        <span>
                          {toFixedWithoutRounding(item?.commission || 0)}
                        </span>
                      </td>
                      <td id="_rebate2" style={{ display: "none" }}>
                        0.00
                      </td>
                      <td id="_payout1" style={{ display: "none" }}>
                        0.00
                      </td>
                      <td id="_tax1" style={{ display: "none" }}>
                        0.00
                      </td>
                      <td id="_rebate1" style={{ display: "none" }}>
                        0.00
                      </td>
                      <td id="_profitLoss1" style={{ display: "none" }}>
                        0.00
                      </td>
                      <td id="_profitLossUpLine">
                        {plSpan(-(item?.amount || 0))}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={14}>You have no bets in this time period.</td>
                  </tr>
                )}

                {!isEmpty(data) && (
                  <tr className="total">
                    <td className="align-L">Total</td>
                    <td id="_totalTax3" />
                    <td id="_totalStake">
                      {toFixedWithoutRounding(sumData?.stake || 0)}
                    </td>
                    <td id="_totalProfitLoss">
                      {plSpan(sumData?.downlinePnl)}
                    </td>
                    <td id="_totalProfitLossDownLine">
                      {plSpan(sumData?.downlinePnl)}
                    </td>
                    <td id="_totalTax3b" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalRebate3" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalTax2">
                      <span>
                        {toFixedWithoutRounding(sumData?.commission || 0)}
                      </span>
                    </td>
                    <td id="_totalRebate2" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalPayout1" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalTax1" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalRebate1" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalProfitLoss1" style={{ display: "none" }}>
                      0.00
                    </td>
                    <td id="_totalProfitLossUpLine">
                      {plSpan(-(sumData?.downlinePnl || 0))}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

            {!isEmpty(data) && (
              <Pagination
                pagination={{ data, totalDocs: data.length }}
                onPageChange={(p) =>
                  setFilter((prev) => ({ ...prev, page: p }))
                }
              />
            )}
          </div>
        </div>
      </div>

      <ProfitLossReportModal
        isOpen={show}
        onClose={() => setShow(false)}
        item={detailsData}
        parentFilter={filter}
      />
    </app-pnl-match>
  );
};

export default ReportByMarket;
